import React from "react";
import styled from "styled-components";
import { education } from "../../data/constants";
import EducationCard from "../Cards/EducationCard";

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 72px;
`;

const Wrapper = styled.div`
  width: min(1440px, 100%);
  margin: 0 auto;
  padding: 0 48px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  @media (max-width: 640px) {
    padding: 0 16px;
  }
`;

const Title = styled.h2`
  font-size: clamp(28px, 5vw, 42px);
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
`;

const Desc = styled.p`
  font-size: 18px;
  text-align: center;
  max-width: 640px;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const List = styled.div`
  width: 100%;
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Education = () => {
  return (
    <Container id="education">
      <Wrapper>
        <Title>Education</Title>
        <Desc>
          Bachelor of Information Communication Technology, completed in 2025, plus higher secondary school.
        </Desc>
        <List>
          {education.map((item) => (
            <EducationCard key={item.id} education={item} />
          ))}
        </List>
      </Wrapper>
    </Container>
  );
};

export default Education;
